import styled from "styled-components";
import { theme } from "../theme";

export const StyledDecisionCard = styled.div`
	width: 30rem;
	min-height: 32rem;
	height: auto;
	margin-bottom: 1rem;
	padding: 0;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	background-color: ${theme.color.white};
	border-radius: 16px;
	border: 1px solid ${theme.color.blue1};
	position: relative;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	overflow: hidden;
	display: flex;
	flex-direction: column;

	&:hover {
		box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
		transform: translateY(-4px);
		border-color: ${theme.color.blue2};
	}

	.card-header {
		padding: 1.5rem 1.5rem 0 1.5rem;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		margin-bottom: 1rem;
	}

	.badges {
		display: flex;
		gap: 0.5rem;
		flex-wrap: wrap;
		flex: 1;
		margin-right: 1rem;
	}

	.badge {
		padding: 0.5rem 1rem;
		border-radius: 8px;
		font-size: 0.75rem;
		font-weight: 600;
		font-family: ${theme.font.secondary};
		text-transform: uppercase;
		letter-spacing: 0.05em;
		color: ${theme.color.white};
		position: relative;
		backdrop-filter: blur(10px);
		
		&.badge-label {
			background: ${theme.color.white};
			color: ${theme.color.black};
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
			border: 2px solid rgba(0, 0, 0, 0.2);
			
			&::before {
				content: "LABEL: ";
				font-size: 0.65rem;
				font-family: ${theme.font.primary};
				opacity: 0.7;
				color: ${theme.color.gray};
			}
		}
		
		&.badge-category {
			background: ${theme.color.white};
			color: ${theme.color.black};
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
			border: 2px solid rgba(0, 0, 0, 0.2);
			
			&::before {
				content: "CATEGORY: ";
				font-size: 0.65rem;
				font-family: ${theme.font.primary};
				opacity: 0.7;
				color: ${theme.color.gray};
			}
		}
	}

	.card-actions {
		display: flex;
		gap: 0.5rem;
		align-items: center;
		opacity: 0.8;
		transition: opacity 0.2s;
		
		&:hover {
			opacity: 1;
		}
		
		button, a {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 32px;
			height: 32px;
			border-radius: 8px;
			background: rgba(255, 255, 255, 0.9);
			border: 1px solid rgba(0, 0, 0, 0.1);
			cursor: pointer;
			color: ${theme.color.gray};
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
			backdrop-filter: blur(10px);
			
			&:hover {
				background: rgba(255, 255, 255, 1);
				border-color: rgba(0, 0, 0, 0.15);
				transform: translateY(-1px);
				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
			}
			
			img, svg {
				width: 16px;
				height: 16px;
			}
		}
	}

	.card-content {
		padding: 0 1.5rem;
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	a:first-child {
		position: absolute;
		top: 0.7rem;
		right: 1rem;
		cursor: pointer;
	}

	.label {
		margin-bottom: 0.75rem;
		background: ${theme.color.white};
		color: ${theme.color.black};
		padding: 0.4rem 1rem;
		border-radius: 1.25rem;
		font-size: 0.7rem;
		font-weight: 600;
		font-family: ${theme.font.secondary};
		text-transform: uppercase;
		letter-spacing: 0.05em;
		display: inline-block !important;
		width: auto !important;
		max-width: fit-content !important;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		border: 2px solid rgba(0, 0, 0, 0.2);
	}

	h3 {
		margin-bottom: 1rem;
		font-size: 1.5rem;
		font-weight: 700;
		font-family: ${theme.font.primary};
		color: ${theme.color.black};
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.description {
		font-size: 0.95rem;
		font-family: ${theme.font.secondary};
		font-weight: 400;
		line-height: 1.6;
		color: ${theme.color.gray};
		margin-bottom: 1.5rem;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}

	.card-footer {
		padding: 0 1.5rem 1.5rem 1.5rem;
		margin-top: auto;
		text-align: center;
		
		.preview-text {
			color: #33AF89;
			font-family: ${theme.font.secondary};
			font-size: 1rem;
			font-weight: 600;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			cursor: pointer;
			position: relative;
			display: inline-block;
			transition: all 0.3s ease;
			
			&::after {
				content: '';
				position: absolute;
				bottom: -4px;
				left: 50%;
				width: 0;
				height: 2px;
				background: #33AF89;
				transition: all 0.3s ease;
				transform: translateX(-50%);
			}
			
			&:hover {
				color: #2d9a75;
				transform: translateY(-2px);
				
				&::after {
					width: 100%;
				}
			}
		}
	}

	& > span:not(.label) {
		margin-bottom: 0.4rem;
		display: block;
		color: ${theme.color.gray};
		font-size: 0.8rem;
		font-weight: 500;
		font-family: ${theme.font.secondary};
		text-transform: uppercase;
	}

	p {
		font-size: 1.1rem;
		font-family: ${theme.font.secondary};
		font-weight: 400;
		line-height: 1.5;
		color: ${theme.color.gray};
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		max-height: 72px;
		-webkit-line-clamp: 4;
		-webkit-box-orient: vertical;
	}

	& > p {
		font-weight: 300;
		font-family: ${theme.font.primary};
		margin-bottom: 1rem;
	}

	& button:not(:first-child) {
		width: min-content;
		margin: auto auto 0;
		display: block;
		font-family: ${theme.font.secondary};
		font-size: 1.1rem;
		font-weight: 600;
		text-transform: uppercase;
		white-space: nowrap;
		border-radius: 2rem;
		transition: all 0.2s ease;
		align-self: center;
		margin-top: auto;

		&:hover {
			transform: translateY(-1px);
		}
	}
`;
